var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 3.00078L10.5 3.00037L9.49992 4.00029L5.99992 4L5.99975 6L19.9998 6.00115L19.9999 4.00115L16.4999 4.00086L15.5 3.00078ZM16.9995 9.0009L16.9987 19.0009L8.99869 19.0002L8.99951 9.00025L16.9995 9.0009ZM6.99967 7.00008L18.9997 7.00107L18.9987 19.0011C18.9986 20.1011 18.0985 21.001 16.9985 21.0009L8.99852 21.0002C7.89852 21.0002 6.9986 20.1001 6.99869 19.0001L6.99967 7.00008Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete24Px);
export default __webpack_public_path__ + "static/media/delete_24px.eb678805bf4c93b44c74041650cf8d4b.svg";
export { ForwardRef as ReactComponent };